import { api } from './client';
import type { AuthUser, LoginRequest, LoginResponse } from '../types';

export const authApi = {
  login: (body: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', body).then((r) => r.data),

  me: () => api.get<AuthUser>('/auth/me').then((r) => r.data),
};
